import { TileLayer } from "react-leaflet";
import { API } from "@/lib/api";

export const RainfallLayer = ({ meta, mode, opacity }) => {
  if (!meta) return null;
  const url = mode === "rate" ? meta.rate_tile_url : `${API}/rainfall/accum/${mode}/{z}/{x}/{y}.png`;
  return (
    <TileLayer
      key={`rain-${mode}-${meta.latest_date}`}
      url={url}
      opacity={opacity}
      maxNativeZoom={meta.max_native_zoom}
      zIndex={350}
      attribution="Rainfall: NASA GPM IMERG / GIBS"
    />
  );
};
